.progressTracker {
  margin-bottom: var(--hcr-spacing-4);
}

// Equal-width, single-line labels; doubled selector outranks Honeycomb's padding rule.
.progressTrackerItem.progressTrackerItem {
  flex-basis: 0;
  flex-grow: 1;
  min-width: 0;
  font-size: var(--hcr-font-size-small);

  > span {
    max-width: 100%;
    min-width: 0;
    padding-left: var(--hcr-spacing-2);
    padding-right: var(--hcr-spacing-1);
  }

  &:not(:first-child) > span {
    padding-left: var(--hcr-spacing-3);
  }

  > span > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// Flush the clip-path notch when the last step is current.
.progressTrackerItemLast:has([aria-current])::before {
  clip-path: polygon(4px 0, 100% 0, 100% 100%, 0 100%);
}
